// Fleet constants and helpers
export const VISIT_PRIORITY_COLORS = {
  routine:  { bg: "#ECFDF5", text: "#065F46", border: "#10B981", label: "Routine" },
  urgent:   { bg: "#FFF7ED", text: "#9A3412", border: "#F97316", label: "Urgent" },
  critical: { bg: "#FEF2F2", text: "#991B1B", border: "#EF4444", label: "Critical" },
};

export const VISIT_STATUS_COLORS = {
  unassigned:  { bg: "#FEF3C7", text: "#92400E", label: "Unassigned" },
  assigned:    { bg: "#DBEAFE", text: "#1E40AF", label: "Assigned" },
  accepted:    { bg: "#DBEAFE", text: "#1E40AF", label: "Accepted" },
  en_route:    { bg: "#E0E7FF", text: "#3730A3", label: "En Route" },
  arrived:     { bg: "#FAE8FF", text: "#86198F", label: "Arrived" },
  in_progress: { bg: "#FEF9C3", text: "#854D0E", label: "In Progress" },
  completed:   { bg: "#D1FAE5", text: "#065F46", label: "Completed" },
  cancelled:   { bg: "#F1F5F9", text: "#475569", label: "Cancelled" },
  missed:      { bg: "#FEE2E2", text: "#991B1B", label: "Missed" },
};

export const READINESS_COLORS = {
  ready:               { bg: "#D1FAE5", text: "#065F46", dot: "#10B981", label: "Ready" },
  available_not_ready: { bg: "#FEF3C7", text: "#92400E", dot: "#F59E0B", label: "Available" },
  busy:                { bg: "#FED7AA", text: "#9A3412", dot: "#F97316", label: "Busy" },
  unavailable:         { bg: "#FEE2E2", text: "#991B1B", dot: "#EF4444", label: "Unavailable" },
  offline:             { bg: "#F1F5F9", text: "#475569", dot: "#94A3B8", label: "Offline" },
};

export const VISIT_TYPES = {
  initial_assessment: "Initial Assessment",
  follow_up: "Follow-up Visit",
  medication_admin: "Medication Admin",
  wound_care: "Wound Care",
  lab_collection: "Lab Collection",
  rpm_device_setup: "RPM Device Setup",
  rpm_intervention: "RPM Intervention",
  hotline_follow_up: "Hotline Follow-up",
  physician_review: "Physician Review",
  dietitian_consult: "Dietitian Consult",
};

export const VISIT_SKILLS = [
  "Nurse", "MedicationAdmin", "WoundCare", "Physician", "ClinicalReview", "RpmDevice",
];

export const SOURCE_LABELS = {
  onboarding: "Onboarding",
  rpm: "RPM",
  hotline: "Hotline",
  manual: "Manual",
};

export const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN;
export const DEFAULT_CENTER = { latitude: 24.7136, longitude: 46.6753, zoom: 11 };

// Spread markers that share identical coordinates into a small ring so stacked
// pins (e.g. several clinicians at one facility) are individually visible.
// Shared by the Live Operations Map and the Fleet Command Center so both render
// the exact same markers from /fleet/map.
export function spreadOverlaps(items) {
  const groups = {};
  (items || []).forEach((it) => {
    if (!it.latitude || !it.longitude) return;
    const key = `${it.latitude.toFixed(5)},${it.longitude.toFixed(5)}`;
    (groups[key] = groups[key] || []).push(it);
  });
  const out = [];
  Object.values(groups).forEach((g) => {
    if (g.length === 1) {
      out.push({ ...g[0], _lat: g[0].latitude, _lng: g[0].longitude });
    } else {
      const R = 0.00035; // ~35m radius spread
      g.forEach((it, i) => {
        const angle = (2 * Math.PI * i) / g.length;
        out.push({
          ...it,
          _lat: it.latitude + R * Math.cos(angle),
          _lng: it.longitude + R * Math.sin(angle),
          _stacked: true,
        });
      });
    }
  });
  return out;
}

export function timeAgo(iso) {
  if (!iso) return "—";
  const ms = Date.now() - new Date(iso).getTime();
  if (ms < 60000) return "just now";
  const m = Math.floor(ms / 60000);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  return `${Math.floor(h / 24)}d ago`;
}
